<template>
  <div
    ref="flyIn"
    v-bind:class="
      (event.type === 'Lecture' && event.theme) || event.type === 'JigsawSession' || event.type === 'Workshop'
        ? 'event-item'
        : 'event-item--break'
    "
  >
    <div class="time">
      <span>{{ event.starts | filterTimeFromDate }} - {{ event.ends | filterTimeFromDate }}</span>
      <div class="header__text" v-if="event.theme === 'Dev'">DEV</div>
      <div class="header__text" v-else-if="event.theme === 'Design'">DESIGN</div>
      <div class="header__text" v-else-if="event.theme === 'Tech'">TECH</div>
      <div class="header__text" v-else-if="event.theme === 'Marketing'">MARKETING</div>
    </div>
    <div class="content">
      <div class="header" v-if="event.theme">
        <div class="header__text" v-if="event.theme === 'Dev'">DEV</div>
        <div class="header__text" v-else-if="event.theme === 'Design'">DESIGN</div>
        <div class="header__text" v-else-if="event.theme === 'Tech'">TECH</div>
        <div class="header__text" v-else-if="event.theme === 'Marketing'">MARKETING</div>
        <div class="event-title">
          {{ event.name }}
        </div>
        <button class="button__expand button__expand--azure">
          <img src="@/assets/icons/chevron-bottom.svg" />
        </button>
      </div>
      <div class="event-title" v-if="!event.theme && event.name">
        {{ event.name }}
      </div>
      <div class="lecturers" v-if="event.eventUsers.length !== 0">
        <span v-if="event.eventUsers && event.eventUsers.length === 1">
          {{ event.eventUsers[0].user.firstName }}
          {{ event.eventUsers[0].user.lastName }}
          <span
            v-if="
              event.eventUsers &&
              event.eventUsers.length &&
              event.eventUsers[0].user &&
              event.eventUsers[0].user.lecturerTitle
            "
          >
            {{ event.eventUsers[0].user.lecturerTitle }}
          </span>
        </span>
        <template v-else>
          <span v-for="(eventUser, index) in getSortedEventUsers(event)" v-bind:key="eventUser.userId">
            {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}
            <span v-if="eventUser.user && eventUser.user.lecturerTitle">
              <span v-if="eventUser.userEventRole === 'Moderator'">Moderator,</span>
              {{ eventUser.user.lecturerTitle }}
            </span>
            <span v-if="index !== event.eventUsers.length - 1">,</span>
          </span>
        </template>
      </div>
      <div
        ref="description"
        class="description"
        v-if="event.description || (event.eventUsers && event.eventUsers.length)"
      >
        <div v-if="event.description" class="description__text">
          {{ event.description }}
          <a
            class="event-footage"
            v-if="event.footageLink && event.footageLink.length"
            v-bind:href="event.footageLink"
            target="_blank"
            rel="noreferrer"
          >
            <span class="video-link">Pogledaj predavanje</span>
          </a>
        </div>
        <div
          v-bind:class="{
            'section-user': true,
            'section-user--many': event.eventUsers && event.eventUsers.length && event.eventUsers.length > 3,
          }"
        >
          <div class="user-container" v-for="eventUser in getSortedEventUsers(event)" v-bind:key="eventUser.userId">
            <img
              v-bind:src="getSpeakerImage(getSpeakerNameNormalized(eventUser.user.firstName + eventUser.user.lastName))"
              v-bind:alt="`${eventUser.user.firstName} ${eventUser.user.lastName}`"
            />
            <div class="user-details">
              <div>
                <p class="user-fullname">{{ eventUser.user.firstName }} {{ eventUser.user.lastName }}</p>
                <p class="user-role">{{ eventUser.user.lecturerTitle }}</p>
              </div>
              <img
                class="schedule-logo"
                :class="getSponsorNameNormalized(eventUser.user.id)"
                :src="getSponsorLogo(eventUser.user.id)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventMixin } from '@/mixins';
import { sponsorLogoExtensions } from '@/config';

export default {
  name: 'Event',
  mixins: [eventMixin],
  data() {
    return {
      sponsorLogoExtensions,
    };
  },
  methods: {
    getSponsorNameNormalized(userId) {
      const eventUser = this.event.eventUsers.find(userEvent => userEvent.user.id === userId);

      return eventUser.user.company.name.replace(/\s/g, '').toLowerCase();
    },
    getSponsorLogo: function (userId) {
      const sponsorNameNormalized = this.getSponsorNameNormalized(userId);
      // eslint-disable-next-line
      return require(`@/assets/companies/logos/${sponsorNameNormalized}.${this.sponsorLogoExtensions[sponsorNameNormalized]}`);
    },
    getSpeakerImage: function (speakerNameNormalized) {
      // eslint-disable-next-line
      return require(`@/assets/speakers/images/${speakerNameNormalized}.jpg`);
    },
    getSpeakerNameNormalized: function (speakerName) {
      return speakerName.replace(/\s/g, '').toLowerCase();
    },
  },
};
</script>

<style scoped>
.no-margin {
  margin-left: 0;
}
</style>
